module.exports = __webpack_public_path__ + "img/bioBasedMaterials.50b1286e.jpg";